export const companyOverviewPath = '/companies/:companyName';

export const companyOverviewLegacyPath = '/companies/:companyName/overview';

export const companyInterviewExperiencesPath =
  '/companies/:companyName/interview-experiences';

export const companyWorkExperiencesPath =
  '/companies/:companyName/work-experiences';

export const companySalaryWorkTimesPath =
  '/companies/:companyName/salary-work-times';

export const jobTitleOverviewPath = '/job-titles/:jobTitle';

export const jobTitleOverviewLegacyPath = '/job-titles/:jobTitle/overview';

export const jobTitleInterviewExperiencesPath =
  '/job-titles/:jobTitle/interview-experiences';

export const jobTitleWorkExperiencesPath =
  '/job-titles/:jobTitle/work-experiences';

export const jobTitleSalaryWorkTimesPath =
  '/job-titles/:jobTitle/salary-work-times';
